module.exports = __webpack_public_path__ + "static/webstorm6-40bd65c3bc3f063529627dab19a6e234.png";